/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Col_DateInputs */

const vi_chot_so_col_date = /** @type {(inputs: Chot_So_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời điểm chốt`)
};

/**

* @param {Chot_So_Col_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_col_date = /** @type {((inputs?: Chot_So_Col_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Col_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_col_date(inputs)
});